import { BrandCenterStatus } from "src/app/models/user-resources.model";
import { EntraIdGroupSettings, TenantRetentionPolicyResponse, TenantSensitivityLabel } from "src/app/models/template-creation-context.model";
import { ReduxWrapper } from "../app.state";

export const tenantInformationInitialState: TenantInformationState = {
	apps: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	internalSettings: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	sharingSettings: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	brandCenter: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	sensitivityLabels: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	groupSettings: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	},
	retentionLabels: {
		loading: false,
		loadedOnce: false,
		value: undefined,
		error: undefined
	}
}

export interface TenantInformationState {
	apps: ReduxWrapper<TenantAppCatalogAppsResponse | undefined>,
	internalSettings: ReduxWrapper<TenantInternalSettings | undefined>,
	sharingSettings: ReduxWrapper<SharingSettings | undefined>
	brandCenter: ReduxWrapper<BrandCenterStatus | undefined>
	sensitivityLabels: ReduxWrapper<TenantSensitivityLabel[] | undefined>
	groupSettings: ReduxWrapper<EntraIdGroupSettings[] | undefined>
	retentionLabels: ReduxWrapper<TenantRetentionPolicyResponse | undefined>
}


export interface TenantAppCatalogAppsResponse {
	apps: App[];
	tenantAppCatalogUri: string;
}

export interface App {
	id: string;
	productId: string;
	appCatalogVersion: string;
	title: string;
	deployed: boolean;
	canUpgrade: boolean;
}

export interface TenantInternalSettings {
	autoQuotaEnabled: boolean;
	newSiteManagedPath: string;
	newTeamSiteManagedPath: string;
	availableManagedPathsForSiteCreation: string[];
}

export interface SharingSettings {
	sharingCapability: SharingCapability;
	defaultSharingLinkType: SharingLinkType;
	defaultLinkPermission: DefaultSharingLinkPermission;
	requireAnonymousLinksExpireInDays: number;
	fileAnonymousLinkType: AnonymousLinkType;
	folderAnonymousLinkType: AnonymousLinkType;
	preventExternalUsersFromResharing: boolean;
	requireAcceptingAccountMatchInvitedAccount: boolean;
	sharingDomainRestrictionMode: SharingDomainRestrictionMode;
	allowedDomainList: string[];
	blockedDomainList: string[];
	externalUserExpireInDays: number;
	externalUserExpirationRequired: boolean;
	whoCanShareAllowListInTenantByPrincipalIdentity: string[] | null;
	guestSharingGroupAllowListInTenantByPrincipalIdentity: string[] | null;
}

export enum SharingCapability {
	Disabled, //anyone with the link  Don't allow sharing outside your organization
	ExternalUserSharingOnly, // Allow external users who accept sharing invitations and sign in as authenticated
	ExternalUserAndGuestSharing, //Allow sharing with all external users, and by using anonymous access links
	ExistingExternalUserSharingOnly, //Allow sharing only with the external users that already exist in your organization's
}

export enum DefaultSharingLinkPermission {
	None,
	View,
	Edit
}

export enum SharingLinkType {
	None,
	Direct,
	Internal,
	AnonymousAccess,
	ExistingAccess
}

export enum SharingDomainRestrictionMode {
	None,
	AllowList,
	BlockList
}

export enum AnonymousLinkType {
	None,
	View,
	Edit
}
